<template>
	<v-container>
		<Editar />
		<Excluir />
		<Nova :mostrar.sync="abrirNovaPublicacao"/>
		<v-row>
			<v-col>
				<v-card :loading="loading" :height="this.$store.getters.alturaContent -60" cols="12">
					<v-card-title>
						<v-toolbar flat dense>
						<v-spacer></v-spacer>
							<v-btn color="primary" small @click="novaPublicacao()">Novo</v-btn>
						</v-toolbar>
					</v-card-title>
					<v-card-text>
						<v-data-table :page.sync="pagina" locale="pt-BR" hide-default-footer dense fixed-header :items="publicacoes" 
						:headers="fields" :items-per-page="itensPorPagina" :height="this.$store.getters.alturaContent - 210">
							<template v-slot:item.action="{ item }">
								<v-btn icon color="primary" id="btn-doacao" @click="editar(item)"><v-icon>mdi-pencil</v-icon></v-btn>
								<v-btn icon color="primary" :disabled="item.status != 'rascunho'" id="btn-doacao" @click="excluir(item)"><v-icon>mdi-delete</v-icon></v-btn>
							</template>
						</v-data-table>
					</v-card-text>
					<v-card-actions>
						<v-row>
						<v-col cols="12">
							<v-pagination dense :length="totalPaginas" total-visible="7" v-model="pagina">
							</v-pagination>
						</v-col>
						</v-row>
					</v-card-actions>
					
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	import {mapState} from 'vuex'
	import { baseApiUrl, showError, showSuccess } from "@/config/global"
    import axios from 'axios'
	import Br from '@/config/barramento'
	import Editar from '@/components/estudos/EditarPublicacao'
	import Excluir from '@/components/estudos/ExcluirPublicacao'
	import Nova from '@/components/estudos/NovaPublicacao'
    
	export default{
		name: 'MinhasPublicacoes',
		components: {Editar, Excluir, Nova},
        computed: {
			...mapState(['user', 'buscandoDados']),
		},
		data(){
			return {
				
				showModal: false,
				abrirNovaPublicacao: false,
				registro: {},
				totalPaginas: 1,
				itensPorPagina: 8,
				pagina: 1,
				fields: [
					{value: 'nome', text: 'Nome'},
					{value: 'data', text: 'Data'},
					{value: 'grau', text: 'Grau'},
					{value: 'autor', text: 'Autor'},
					{value: 'status', text: 'Status'},
					{text: 'Ações', value: 'action', align: 'center', divider: true}
				],
				publicacoes: [],
				loading: false
			}
		},

        methods:{
			
			isDisabled(item){
				return item.status == 'inativo' ? true : false
			},

            carregarPublicacoes(){
				this.loading = true
				const url = `${baseApiUrl}/estudos/minhasPublicacoes.php?user=${this.user.iniciado}&grau=${this.user.dados.grauAtual}`
				axios.get(url)
				.then(res => {
					if(res.data.codigo == '01'){
						this.publicacoes = res.data.dados
						this.totalPaginas = Math.ceil(this.publicacoes.length / this.itensPorPagina)
						this.loading = false
					}else{
						this.loading = false
						showError(res.data.mensagem)
					}

					
				})
				.catch({showError})
			},

            editar(item){
				this.$store.commit('setLoading', true)
                Br.setEditarPublicacao(item)
			},

			novaPublicacao(){
				this.abrirNovaPublicacao = true
			},

            excluir(publicacao){

				Br.setExcluirPublicacao(publicacao)

                // if(this.registro.status == 'rascunho'){
                //     const url = `${baseApiUrl}/estudos/delete.php`
                    
                //     axios.post(url, {id: this.registro.id})
                //         .then(res => {

                //             if(res.data.codigo == '01'){
                //                 showSuccess('Publicação excluida com sucesso')
                //                 this.carregarPublicacoes(this.paginaAtual)
                //             }else{
                //                 showError(res.data.mensagem)
                //             }
				// 		})
						
				// 		this.close()
                // }else{
                //     showError('Não é possivel excluir uma publicação ativa!')
                // }
			},

			inativar(){

                    const url = `${baseApiUrl}/estudos/inativar.php`
                    
                    axios.post(url, {id: this.registro.id})
                        .then(res => {

                            if(res.data.codigo == '01'){
                                showSuccess(res.data.mensagem)
                                this.carregarPublicacoes(this.paginaAtual)
                            }else{
                                showError(res.data.mensagem)
                            }
						})
						
						this.close()
			},

			verificaExclusao(registro){
				
				if(registro.status == 'rascunho'){
					this.registro = registro
					this.registro.mensagemExclusao = "Você confirma a exclusão dessa publicação?"
					this.showModal = true
				}else if(registro.status == "inativo"){
					showError("Texto ja foi inativado")
				}else{
					
					this.registro = registro
					this.registro.mensagemExclusao = "O registro será inativado, você confirma a operação?"
					this.showModal = true
				}
				
				
			},

			close(){
				this.showModal = false
			}
        },

        created(){

			this.carregarPublicacoes()
			
			Br.onPublicacaoExcluida(publicacao => {
				let idx = this.publicacoes.findIndex(v =>{
					return v.id == publicacao.id
				})

				this.publicacoes.splice(idx, 1)
			})

			Br.onPublicacaoCadastrada(publicacao => {
				this.publicacoes.push(publicacao)
			})

			Br.onPublicacaoAtualizada(publicacao => {
				let idx = this.publicacoes.findIndex((v) => {
					return v.id == publicacao.id
				})

				this.publicacoes[idx] = publicacao
			})

        },
	}
</script>

<style scoped>

</style>